import * as React from 'react';
import { Link } from 'react-router-dom';

export const AddAccountLink = () => (
  <li>
    <Link to="/add-account">Add Bank Account</Link>
  </li>
);

export const OverviewLink = () => (
  <li>
    <Link to="/overview">Overview</Link>
  </li>
);

export const SearchLink = () => (
  <li>
    <Link to="/search-expenses">Search</Link>
  </li>
);

export const ContactUsLink = ({ icon = false }) =>
  icon ? (
    <li>
      <a target="_blank" href="mailto:support@mail.kimbix.com">
        <i className="material-icons">email</i>
      </a>
    </li>
  ) : (
    <li>
      <a href="mailto:support@mail.kimbix.com">Contact us</a>
    </li>
  );

export const SettingsLink = () => (
  <li>
    <Link to="/settings">Settings</Link>
  </li>
);

export const LogoutLink = ({ logout }) => (
  <li>
    <a onClick={logout}>Logout</a>
  </li>
);

export const LoginLink = () => (
  <li>
    <Link to="/login">Login</Link>
  </li>
);

export const SignupLink = () => (
  <li>
    <Link to="/signup">Sign up</Link>
  </li>
);



// WEBPACK FOOTER //
// ./src/my-app/links.tsx